import $i from "~/i18n";
export const getFvorite = async ({ commit }) => {
  try {
    let { data } = await axios.post(`/wishlist/get`);
    if (data.state != 200) return;
    commit("SET_DATA", { data: data.wishlist, id: "fvoriteList" });
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/favorite/actions.js